export default (store) => {
    return {
        setLocalStorageItem: (name, value,) => {
            // if (store.getters.integracao && !store.getters.permissaoSistemaCompletoIntegracao)
            //     return
            try {
                localStorage.setItem(name, value)
            } catch {}
        },
        getLocalStorageItem: (name) => {
            // if (store.getters.integracao && !store.getters.permissaoSistemaCompletoIntegracao)
            //     return null
            try {
                return localStorage.getItem(name) || null
            } catch {
                return null
            }
        },
        removeLocalStorageItem: (name) => {
            // if (store.getters.integracao && !store.getters.permissaoSistemaCompletoIntegracao)
            //     return
            try {
                return localStorage.removeItem(name)
            } catch {
                return null
            }
        },
        getToken() {
            // if (store.getters.integracao && !store.getters.permissaoSistemaCompletoIntegracao)
            //     return store.getters.token
            try {
                return localStorage.getItem('vistra_token')
            } catch {}
        },
        setSessionStorageItem: (name, value) => {
            // if (store.getters.integracao && !store.getters.permissaoSistemaCompletoIntegracao)
            //     return
            try {
                sessionStorage.setItem(name, value)
            } catch {}
        },
    }
}